import React, { useState, useEffect } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Skeleton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import he from 'he';
import { scroller } from 'react-scroll';
import { ContentIArticleList } from '@/interfaces/help';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

interface ContentArticleListProps {
    articles: ContentIArticleList[]; 
    loading: boolean;
}

const ContentArticleList: React.FC<ContentArticleListProps> = ({ articles, loading }) => {

    const router = useRouter();
    const { slug } = router.query;
  




    const [expanded, setExpanded] = useState<string | false>(false);

    const handleChange = (panel: string, categorySlug: string) => (
        event: React.SyntheticEvent,
        isExpanded: boolean
    ) => {
        setExpanded(isExpanded ? panel : false);

        setTimeout(() => {
            scroller.scrollTo(panel, {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -100,
            });
        }, 500);

    };

    const handleToindex = () => {
        router.push("/help/shop")
    }

    useEffect(() => {
        if (slug && Array.isArray(slug)) {
            const slugValue = slug[2];
            if (slugValue) {
                const matchedArticleIndex = articles.findIndex(
                    (article) => article.slug === slugValue
                );

                if (matchedArticleIndex !== -1) {
                    const panelId = `panel${articles[matchedArticleIndex].id}`;
                    setExpanded(panelId);

                    setTimeout(() => {
                        scroller.scrollTo(panelId, {
                            duration: 800,
                            delay: 0,
                            smooth: 'easeInOutQuart',
                            offset: -100,
                        });
                    }, 500);
                }
            }
        }
    }, [slug, articles]);


    return (
        <>
            <Typography
                sx={{
                    fontSize: "16px",
                    color: "#717275",
                    cursor:"pointer"
                }}
                onClick={handleToindex}
            >
                <FontAwesomeIcon icon={faChevronLeft} fontSize='14px' />
                ย้อนกลับ
            </Typography>
            {loading ? (
                <>
                    <Skeleton variant="text" width="80%" height={40} />
                    <Skeleton variant="rectangular" width="100%" height={200} />
                </>
            ) : (
                <>
                    <Typography sx={{ my: 1, fontSize: 20 }} className="txt-bold">
                        {Array.isArray(slug) ? slug.join(' / ') : slug}
                    </Typography>
                    <Box>
                        {articles.length > 0 ? (
                            articles.map((article) => (
                                <Accordion
                                    key={article.id}
                                    expanded={expanded === `panel${article.id}`}
                                    onChange={handleChange(`panel${article.id}`, article.slug)}
                                    sx={{
                                        borderBottom: '1px solid #ccc',
                                        boxShadow: 'none',
                                        '&:before': {
                                            display: 'none',
                                        },
                                        py: 1,
                                    }}
                                >
                                    <AccordionSummary sx={{
                                        '&:hover': {
                                            color: '#DB5A00',
                                        },
                                    }} id={`panel${article.id}`} expandIcon={<ExpandMoreIcon />}>

                                        <Typography>{he.decode(article.title)}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography dangerouslySetInnerHTML={{ __html: he.decode(article.content) }} />
                                    </AccordionDetails>
                                </Accordion>
                            ))
                        ) : (
                            <Typography variant="h6" sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '30vh'
                            }}>ไม่พบการค้นหา</Typography>
                        )}
                    </Box>
                </>
            )}
        </>
    );
};

export default ContentArticleList;
